<template>
    <MainContentSearchable
        title="Listado de plantillas"
        id="plantillas"
        v-model="filtersPlantillas"
        :meta="loading ? {} : plantillas.meta"
        :disabled="loading"
        @updated="debouncedGetPlantillas"
    >
        <template v-slot:header>
            <h3 class="card-title pt-2">Listado de plantillas</h3>
            <div class="card-tools mb-3">
                <router-link
                    :to="{ name: 'back.emails.plantilla.crear' }"
                    class="btn btn-primary"
                    id="crear-boletin"
                >
                    Crear plantilla
                </router-link>
            </div>
        </template>

        <template v-slot:extra-options>
            <div class="col-12 col-lg-9 pr-0 mr-0">
                <div class="input-group-sm my-3">

                    <select class="custom-select w-auto mr-2" v-model="filtersPlantillas.order" @change="getListadoPlantillas">
                        <option value="" disabled>Orden</option>
                        <option value="asc">Ascendente</option>
                        <option value="desc">Descendente</option>
                    </select>

                    <select class="custom-select w-auto mr-2" v-model="filtersPlantillas.sortBy" @change="getListadoPlantillas">
                        <option value="" disabled>Filtrar por</option>
                        <option value="nombre">Nombre</option>
                        <option value="created_at">Fecha de creación</option>
                        <option value="updated_at">Última actualización</option>
                    </select>
                </div>
            </div>
        </template>
        

        <template v-slot:content>
            <b-row>
                <b-col cols="12">
                    <ContainerTable :data="plantillas.data" :responsive="esMovil">
                        <b-table 
                            hover 
                            :items="plantillas.data" 
                            :fields="fields" 
                            :busy="loading" 
                            empty-text="No hay plantillas creadas"
                        >
                            <template #cell(created_at)="{ item }">
                                {{ item.created_at }}
                            </template>
                            <template #cell(updated_at)="{ item }">
                                {{ item.updated_at }}
                            </template>
                            <template #cell(opciones)="{ item, index }">
                                <OpcionesDropdownTableComponent
                                    :lastIndex="plantillas.data.length > 3 && index >= plantillas.data.length - 3"
                                    :options="[
                                        { type: 'action', action: () => editarPlantilla(item.id), label: 'Editar'},
                                        { type: 'action', action: () => showModal('borrar-' + item.id), label: 'Borrar' }
                                    ]"
                                />
                                <BorrarModalComponent
                                    confirmButton="¿Está segur@ de borrar esta plantilla?"
                                    :name="'borrar-' + item.id"
                                    :title="'Borrar plantilla ' + item.nombre"
                                    @close="() => closeModal('borrar-' + item.id, false)"
                                    @confirm="() => eliminarPlantilla(item.id)"
                                />
                            </template>
                        </b-table>
                    </ContainerTable>
                </b-col>
            </b-row>
        </template>
    </MainContentSearchable>

</template>

<script>
    import MainContentSearchable from '@/components/backend/components/MainContentSearchable';
    import apiService from '@/services/api-comunicados';
    import ContainerTable from '@/components/backend/common/ContainerTable';
    import OpcionesDropdownTableComponent from "@/components/backend/components/OpcionesDropdownTableComponent";
    import BorrarModalComponent from '@/components/backend/components/BorrarModalComponent.vue';
    import _ from 'lodash';

    export default {
        data() {
            return {
                loading: false,
                fields: [
                    { key: "nombre", label: "Nombre" },
                    { key: "description", label: "Descripción" },
                    { key: "created_at", label: "Fecha de creación", class: "text-center" },
                    { key: "updated_at", label: "Última actualización", class: "text-center" },
                    { key: "opciones", label: "Opciones", class: "text-center" }
                ],
                filtersPlantillas: {
                    search:'',
                    order: 'desc',
                    sortBy: 'created_at',
                    per_page: 10,
                    page: 1
                },
                plantillas: {
                    data: [],
                    meta: {
                        current_page: 1,
                        per_page: 10,
                        total: 0,
                        last_page: 1
                    }
                },
            }
        },
        created() {
            this.getListadoPlantillas(true);
            this.debouncedGetPlantillas = _.debounce(this.getListadoPlantillas, 500);
        },
        methods: {
            async getListadoPlantillas(toSelect = false)
            {
                try {
                    this.loading = true;
                    
                    const params = { ...this.filtersPlantillas };
                    if (toSelect) {
                        params.to_select = "true";
                    }
                    
                    const response = await apiService.getListadoPlantillas(params);
                    
                    this.plantillas = {
                        data: response.data || [],
                        meta: response.meta || {
                            current_page: 1,
                            per_page: 10,
                            total: 0,
                            last_page: 1
                        }
                    };
                } catch (error) {
                    this.$toast.error("Error al cargar listado de plantillas");
                    this.plantillas = {
                        data: [],
                        meta: {
                            current_page: 1,
                            per_page: 10,
                            total: 0,
                            last_page: 1
                        }
                    };
                } finally {
                    this.loading = false;
                }
            },

            async eliminarPlantilla(id)
            {
                try {
                    const response = await apiService.borrarPlantilla(id);
                    
                    this.$toast.success(response.message);
                    this.closeModal('borrar-' + id, true);
                } catch (error) {
                    this.$toast.error("Error al eliminar la plantilla");
                    this.closeModal('borrar-' + id, false);
                }
            },

            showModal(modal) {
                this.$modal.show(modal);
            },

            closeModal(modal, eliminado) {
                this.$modal.hide(modal);
                if (eliminado) {
                    this.getListadoPlantillas(); 
                } 
            },
            async editarPlantilla(id)
            {
                this.$router.push({ name: 'back.emails.plantilla.editar', params: { plantilla_id: id } });
            }
        },
        computed: {
            esMovil() {
                return window.innerWidth <= 768;
            }
        },
        watch: {
        },
        components: {
            MainContentSearchable, ContainerTable, OpcionesDropdownTableComponent, BorrarModalComponent
        }
    }
</script>